<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>

  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>Platform Master</h1>

        @if (pageLoading) {
        <app-platform-master-skeleton></app-platform-master-skeleton>
        }

        @if (!pageLoading) {
        <app-spinner [isLoading]="isLoading" diameter="50" loadingText="Adding platform..."></app-spinner>

        @if (successMessage) {
        <div class="alert alert-success">
          <mat-icon>check_circle</mat-icon>
          {{ successMessage }}
        </div>
        }

        @if (errorMessage) {
        <div class="alert alert-danger">
          <mat-icon>error_outline</mat-icon>
          {{ errorMessage }}
        </div>
        }

        <!-- Add Platform Master Button -->
        <button type="button" class="btn btn-primary no-arrow" (click)="toggleForm()" [disabled]="showForm"
          style="margin-bottom: 20px;">
          Add Platform Master
        </button>

        @if(infoMessage) {
        <div class="alert alert-info">
          <mat-icon>info</mat-icon>
          {{ infoMessage }}
        </div>
        }

        <!-- Add Platform Master Form -->
        @if (showForm) {
        <div class="card" style="margin-bottom: 20px;">
          <div class="card-body">
            <h4 class="card-title mb-3">Add Platform Master</h4>
            <form #platformForm="ngForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <label for="userEmail" class="form-label">User Email <span class="required">*</span></label>
                <div class="autocomplete-wrapper">
                  <input type="text" id="userEmail" class="form-control" placeholder="Search user (min 3 characters)"
                    [formControl]="emailControl" (focus)="showSuggestions = true" (blur)="onEmailBlur()"
                    autocomplete="off" [disabled]="isLoading" />
                  @if (showSuggestions && (filteredUsers$ | async); as users) {
                  <ul class="autocomplete-dropdown">
                    @if (users.length === 0) {
                    <li class="autocomplete-empty">No users found</li>
                    }
                    @for (user of users; track user.id) {
                    <li class="autocomplete-option" (mousedown)="onUserSelected(user)">
                      <span class="fw-semibold">{{ user.displayName }}</span>
                      <small class="text-muted d-block">{{ user.mail }}</small>
                    </li>
                    }
                  </ul>
                  }
                </div>
              </div>

              <div class="form-group">
                <label for="userFunction" class="form-label">User Function <span class="required">*</span></label>
                <select id="userFunction" name="userFunction" class="form-control" [(ngModel)]="platformData.function"
                  required [disabled]="isLoading">
                  <option value="" disabled>Select user function</option>
                  @for (platform of digitalPlatforms; track platform) {
                  <option [value]="platform">{{ platform }}</option>
                  }
                </select>
              </div>

              <div class="form-actions">
                <button type="submit" class="btn btn-primary no-arrow" [disabled]="!platformForm.valid || isLoading">
                  <mat-icon>save</mat-icon>
                  Save
                </button>
                <button type="button" class="btn btn-secondary no-arrow" (click)="onCancel()" [disabled]="isLoading">
                  <mat-icon>cancel</mat-icon>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
        }

        <!-- Platform List Grid -->
        <div class="card">
          <div class="card-body">
            <!-- Function cell template: dropdown when row is being edited, plain text otherwise -->
            <ng-template #functionCellTemplate let-item>
              @if (editingRow === item) {
              <select class="form-control form-control-sm" [(ngModel)]="editingFunction"
                [ngModelOptions]="{standalone: true}">
                <option value="" disabled>Select function</option>
                @for (platform of availableFunctions; track platform) {
                <option [value]="platform">{{ platform }}</option>
                }
              </select>
              } @else {
              {{ item.function }}
              }
            </ng-template>

            <app-data-grid [columns]="platformGridColumns" [data]="platformList" [config]="platformGridConfig"
              [loading]="isGridLoading" [actions]="platformGridActions" [totalCount]="totalPlatformRecords"
              [filterOptions]="gridFilterOptions" [filtersLoaded]="filtersLoaded"
              (actionClicked)="onActionClicked($event)" (pageChanged)="onPageChanged($event)"
              (columnFilterChanged)="onColumnFilterChanged($event)" (sortChanged)="onSortChanged($event)">
            </app-data-grid>
          </div>
        </div>
        }
      </div>
    </div>
  </section>
</main>